import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";

import classNames from "classnames";
import { useAutoClose } from "~/hooks/useAutoClose";
import { useIsMobileV2 } from "~/hooks/useIsMobile";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

export const useTooltip = (): {
    showTooltip: boolean;
    handleTooltipClick: (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => void;
    setShowTooltip: React.Dispatch<React.SetStateAction<boolean>>;
} => {
    const [showTooltip, setShowTooltip, closeTooltip] = useAutoClose(false);

    const handleTooltipClick = (
        e: React.MouseEvent<HTMLButtonElement, MouseEvent>,
    ) => {
        const isMobile = useIsMobileV2();
        if (isMobile) {
            e.stopPropagation();
            e.preventDefault();
            setShowTooltip(true);
        } else setShowTooltip(!showTooltip);
    };

    return { showTooltip, handleTooltipClick, setShowTooltip };
};

const TooltipContent = React.forwardRef<
    React.ElementRef<typeof TooltipPrimitive.Content>,
    React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => (
    <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={classNames(
            `bg-popover text-popover-foreground z-50 m-[6px] overflow-hidden 
      rounded-md border border-transparent 
      bg-black px-3 py-1.5 
      text-sm text-white opacity-80 shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0
      data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2`,
            className,
        )}
        {...props}
    />
));
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
